import { useEffect, useState } from "react";
import axios from "axios";
import { Helmet } from "react-helmet-async";

const API = process.env.REACT_APP_API_LOCAL_URL;

const SeoMeta = ({ slug, fallback }) => {
    const [meta, setMeta] = useState(null);
    console.log("meta seo")
    useEffect(() => {
        const fetchMeta = async () => {
            try {
                const res = await axios.get(`${API}seo-meta`,{
                    params: {
                        slug: slug
                    }
                });
                setMeta(res.data);
            } catch (err) {
                console.log("SEO API failed, using fallback");
                setMeta(null);
            }
        };

        fetchMeta();
    }, [slug]);

    const title =
        meta?.page_title || fallback.title;

    const description =
        meta?.page_description || fallback.description;

    const ogImage =
        meta?.og_image || fallback.image || "";

    const url =
        meta?.canonical_url || fallback.url;

    return (
        <Helmet>
            <title>{title}</title>

            <meta name="description" content={description} />

            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={ogImage} />
            <meta property="og:url" content={url} />
            <meta property="og:type" content="article" />

            <meta name="robots" content={meta?.robots || "index,follow"} />
            <link
                rel="canonical"
                href={url}
            />
        </Helmet>
    );
};

export default SeoMeta;